import { createSelector } from "@reduxjs/toolkit";
import selectMemberMemberships from "./selectMemberMemberships";

export default createSelector(
	selectMemberMemberships,
	(memberships) =>
		!!(memberships && memberships.length > 0 && memberships[0].stripe_user_id && memberships[0].paymentMethod)
);
